export enum CounterpartyFilterType {
  Default = 'default',
  NotValidated = 'notValidated'
}
